import { Typewriter } from "../Typewriter";

import { LabelDiv } from "./Label.styles";
import {
    Blue,
    Green,
    Magenta,
    Neutral,
    Purple,
    Teal,
    Yellow
} from "./patterns";

export type LabelTheme =
    | "Blue"
    | "Green"
    | "Magenta"
    | "Neutral"
    | "Purple"
    | "Teal"
    | "Yellow";

export const labelThemeOptions: LabelTheme[] = [
    "Yellow",
    "Green",
    "Teal",
    "Magenta",
    "Blue",
    "Purple",
    "Neutral"
];

export type LabelProps = {
    className?: string;
    text: string;
    theme: LabelTheme;
};

export const Label = ({ className, text, theme }: LabelProps) => {
    const patterns = {
        Blue,
        Green,
        Magenta,
        Neutral,
        Purple,
        Teal,
        Yellow
    };
    const colors = {
        Blue: "B200",
        Green: "G200",
        Magenta: "M200",
        Neutral: "N600",
        Purple: "P200",
        Teal: "T200",
        Yellow: "Y200"
    };
    return (
        <LabelDiv
            aria-hidden={true}
            className={className}
            color={colors[theme]}
        >
            {patterns[theme]}
            <Typewriter text={text} />
        </LabelDiv>
    );
};
